module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ckZEW"))).then(() => parcelRequire('2KbAe'));